import queryString from 'query-string';
import ignite from '../../../../services';
import getLogger from '@ignitesales/logger-es';
import {SALESFORCE_ACCOUNT_ID_APPKEY} from '../../../../utils/constants.mjs';

const logger = getLogger({ module: 'saveUrlParameters' });
const urlQueryAnswerKey = 'urlParameters';

const defaultMapping = {
  salesforceAccountId: SALESFORCE_ACCOUNT_ID_APPKEY
};

/**
 * @param mapping {Object} - key to string pairs, where the key is the url param name and the value is the appkey to save url param value
 * @returns {Promise<*>}
 */
const saveUrlParameters = async ( mapping ) => {
  const urlParamAnswerMap = { ...defaultMapping, ...mapping };
  const urlQuery = window.location.search;

  if(urlQuery) {
    logger.debug('Checking url params to save answers', {urlParamAnswerMap, urlQuery});
    try {
      const parsedUrlParams = queryString.parse(urlQuery);
      for(const urlParamKey in urlParamAnswerMap) {
        const appkey = urlParamAnswerMap[urlParamKey];
        const value = parsedUrlParams[urlParamKey];
        if (appkey && value) {
          logger.debug('Saving url param', {urlParamKey, appkey, value});
          await ignite.answerService.saveAnswer({
            appkey, value, timestamp: new Date()
          });
        }
      }

      //Save the URL query once done mapping answers
      const currentUrlParamsAnswer = await ignite.answerService.getAnswer(urlQueryAnswerKey);
      const stampedQuery = `${urlQuery} | ${new Date().toISOString()}`;
      const valueToSave = currentUrlParamsAnswer?.value && currentUrlParamsAnswer?.value.length > 0 ? currentUrlParamsAnswer.value.concat(stampedQuery) : stampedQuery;
      await ignite.answerService.saveAnswer({
        appkey: urlQueryAnswerKey,
        value: valueToSave,
        timestamp: new Date()
      });
    } catch (ex) {
      logger.error('Failed to finish saving URL params', ex);
    }
  }
};


export {
  saveUrlParameters
};
